module.exports = __webpack_public_path__ + "img/Vector.119a6567.png";